export default __webpack_public_path__ + "static/media/CSS_NOTES.54021854.xlsx";